<div class="auth-wrapper">
  <div class="auth-brand-container">
    <div class="brand-wrapper">
      <div class="image-container">
        <img [src]="'assets/img/account/auth-flow-background.jpg'" />
      </div>
      <div class="brand-logo-container">
        <img
          (click)="logoClicked()"
          alt="bs"
          class="brand-logo"
          src="../../../../../assets/logo/light/logo-filled.svg" />
      </div>
    </div>
    <div class="software-version">
      {{ viewModel?.versionString }}
    </div>
  </div>
  <div class="auth-action-container">
    <app-sign-in *rxIf="viewModel.isSignIn$; strategy: 'immediate'" />
    <app-forgot-password *rxIf="viewModel.isForgotPassword$; strategy: 'immediate'" />
    <app-reset-password *rxIf="viewModel.isResetPassword$; strategy: 'immediate'" />
    <app-new-password *rxIf="viewModel.isSetNewPassword$; strategy: 'immediate'" />
    <app-toast-events [containerPosition]="'absolute'" [margin]="'1rem'"> </app-toast-events>
  </div>
</div>
